import React from 'react';
import {getLocale} from "@apps/Shared/Utils/Utils";
import ExtraPickupFormBlock from "@apps/Shared/Blocks/ExtraPickupFormBlock/ExtraPickupFormBlock";
import {useExtraPickupFormBlockQuery} from "@apps/Shared/GraphQL/generated";
import {ExtraPickupFormBlockProps} from "@apps/Shared/Blocks/ExtraPickupFormBlock/types";

function App(): JSX.Element {
    const hiddenInput = document.querySelector('.js-extra-pickup-form');
    const id = Number((hiddenInput as HTMLInputElement)?.value);
    const locale = getLocale();

    const {data} = useExtraPickupFormBlockQuery({
        id: id,
        locale: [locale]
    });

    if (data && data.ExtraPickupFormBlockModel?.items && data.ExtraPickupFormBlockModel?.items?.length > 0) {
        const item: any = data?.ExtraPickupFormBlockModel.items[0];
        const props: ExtraPickupFormBlockProps = {
            heading: item.Heading,
            confirmationText: item.ConfirmationText.Html
        }

        return (
            <ExtraPickupFormBlock {...props} />
        )
    } else {
        return <></>
    }
}

export default App;